<template>
  <div>
    <el-dialog title="Email" :visible.sync="dialogVisible" :before-close="handleCancel">
      <el-form ref="enrolmentForm" :model="enrolment" label-position="top">
        <el-row :gutter="20">
          <el-form-item label="Asunto">
            <el-input v-model="data.subject" placeholder="Añadir asunto" />
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="Mensaje">
            <el-input v-model="data.message" :rows="5" type="textarea" />
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">Cancelar</el-button>
        <el-button type="primary" @click="handleSubmit()">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: ['dialogVisible','userId'],
    data() {
      return {
        data: {
          subject: '',
          message: '',
        }
      }
    },
    created() {
    },
    methods: {
      handleSubmit() {
        axios.post(`users/${this.userId}/email-json`, this.data)
        .then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 5000,
          });
          this.handleCancel();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleCancel(done) {
        this.$emit('dialogVisible', false);
      },
    },
  }
</script>
<style scoped>
  .v-modal {
    z-index: 0 !important;
  }
</style>